(()=>{
  function observeFirst(targetNode,config,timeout,callback) {
    return new Promise((resolve, reject)=>{
      const Rcallback = (mutationList, observer) => {
        callback(mutationList,observer,resolve,reject);
      };
      const observer = new MutationObserver(Rcallback);
      observer.observe(targetNode, config);
      if (timeout!=0){
        setTimeout(()=>{observer.disconnect();reject();},timeout||2000);
      }
    });
  }
  function observeEleClass(targetNode,className,timeout) {
    const check = targetNode.querySelector("* > ."+className);
    if (check) { return new Promise((a,b)=>{a(check)})};
    const config = { childList: true };
    return observeFirst(targetNode,config,timeout,(mutationList, observer,resolve,reject) => {
      for (const mutation of mutationList) {
        mutation.addedNodes.forEach((ele)=>{
          if (ele.classList.contains(className)) {
            observer.disconnect();
            resolve(ele);
            return;
          }
        });
      }
    });
  }
  function observeEleAddClass(targetNode,className,timeout) {
    //if (targetNode.classList.contains(className)) { return new Promise((a,b)=>{a(targetNode)})};
    const config = { attributes: true ,attributeFilter:["class"]};
    return observeFirst(targetNode,config,timeout,(mutationList, observer,resolve,reject) => {
      for (const mutation of mutationList) {
        if ((targetNode.classList.contains(className))) {
          observer.disconnect();
          resolve(targetNode);
          return;
        }
      }
    });
  }
  function forEachAsync(arr,callback) {
    const promises = [];
    arr.forEach((a,b,c)=>{ 
      promises.push(callback(a,b,c));
    });
    Promise.all(promises);
  }
  function waitOnEvent(ele,event) {
    return new Promise((resolve, reject)=>{
      function callback(e) {
        resolve(e);
        ele.removeEventListener(event,callback);
      }
      ele.addEventListener(event,callback);
    });
  }
  function wait(timeout) {
    return new Promise((resolve, reject)=>{
      if (timeout!=0) {
        setTimeout(()=>{resolve();},timeout);
      }else{
        resolve();
      }
    });
  }
  function createModal() {
    const modal = document.createElement("div");
    modal.classList.add("fnd-gpo-image-modal");
    document.body.appendChild(modal);
    let self = {};
    self = {
      openable: true,
      element: modal,
      isOpen: () => (modal.classList.contains("modal-open")),
      open: () => {
        if ((!self.isOpen())&&(self.openable)){
          modal.classList.add("modal-open");
          const func = async () => {
            await wait(200);
            while (true) {
              const event = await waitOnEvent(document.body,"click");
              if (!modal.contains(event.target)) {
                modal.classList.remove("modal-open");
                return;
              }
            }
          };
          func().then(()=>{});
        }
      }
    }
    return self;
  }
  let isRunning = false;
  async function load() {
    if (isRunning) {return;}
    const productInfo = document.querySelector(".product-info__add-to-cart");
    if (productInfo) {
      isRunning = true;

      
      const modal = createModal();
      modal.openable = false;
      modal.element.innerHTML = `
        <img src=""></img>
        <h5></h5>
      `;
      const modalImg = modal.element.querySelector("img");
      const modalText = modal.element.querySelector("h5");
      
      
      const appEle = await observeEleClass(productInfo,"gpo-container");
      const gpoElements = document.querySelectorAll(".gpo-element:has(.image-dropdown)");

      
      await forEachAsync(gpoElements,async (ele)=>{ 
        const picture = document.createElement("img");
        const dropdown = ele.querySelector(".gpo-dropdown");

        picture.addEventListener("click",modal.open);
        dropdown.firstElementChild.insertAdjacentElement("beforeBegin",picture);
        while (true){
          await observeEleAddClass(ele,"has-success",0);
          const value = ele.querySelector(".gpo-selected-values").innerText;
          const imgEle = ele.querySelector(`.dropdown-item:has(input[value='${value}']) .gpo-swatch__image`);
          if (!imgEle) {continue;}
          const imgBackground = imgEle.style.background;
          if (!imgBackground||(imgBackground.substr(0,5)!="url(\"")) {continue;}
          
          const imgUrl = imgBackground.substr(5,imgBackground.length-6).split("?")[0];
          picture.style.backgroundImage = imgBackground;
          modal.openable = true;
          picture.style.cursor = "zoom-in";
          modalImg.src = imgUrl;
          modalText.innerText = value;
        }
      });
    }
  }
  load().then(()=>{});
  document.addEventListener("DOMContentLoaded",()=>{
    load().then(()=>{});
  });
})();